import { useContext } from 'react';
import { ErrorContext } from 'data/error/context';
export type { ErrorContextProps } from 'data/error/context';

export const useError = () => useContext(ErrorContext);
